import styled from 'styled-components';

const Text = styled.span`
    color: ${props => (props.color ? props.theme.color[props.color] : 'inherit')} !important;
    font-size: ${props => (props.size ? props.theme.font[props.size] : 'inherit')};
    font-weight: ${props => props.weight ? props.weight : 'inherit'};
    text-align: ${({ align }) => align ? align : 'inherit'};
    margin: ${({ margin }) => margin || 0};
`;
const Link = styled.a`
    text-decoration: none;
    cursor: pointer;
    color: ${props => props.theme.color.primary};
`;
const Color = styled.span`
    color: ${({ theme, hue }) => theme.color[hue]};
    font-weight: 700;
`;
const Box = styled.div`
    max-width: 100%;
    padding: ${({ theme }) => theme.padding.xlrg};
    background: #00000009;
    display: flex;
    flex-direction: column;
    min-height: 1px;
`;

Text.Link = Link;
Text.Color = Color;
Text.Box = Box;
export { Text };



// WEBPACK FOOTER //
// ./src/sc-ui/Text.jsx